declare global {
    interface Window {
        ENV?: Record<string, string | undefined>;
    }
}

/** Runtime configuration from /config.js (Heroku: every APP_* config var; local: public/config.js). */
export const ENV: Record<string, string | undefined> = window.ENV ?? {};
